import { CommonModule } from '@angular/common'
import { Component, inject, input } from '@angular/core'
import { ColorSchemeDirective } from 'src/app/core/directives/color-scheme.directive'
import { I18nText } from 'src/app/core/interfaces/i18n.service'
import { I18nService } from 'src/app/core/services/i18n.service'

@Component({
  selector: 'app-footer-basic',
  templateUrl: './footer-basic.component.html',
  styleUrls: ['./footer-basic.component.scss'],
  imports: [
    CommonModule,
    ColorSchemeDirective,
  ],
})
export class FooterBasicComponent {
  protected i18n = inject(I18nService)

  styles = input<any>({})
  address = input<string>('')
  address_line_2 = input<string>('')
  phone = input<string>('')
  email = input<string>('')
  facebook = input<string>('')
  twitter = input<string>('')
  instagram = input<string>('')
  youtube = input<string>('')
  linkedin = input<string>('')
  copyright_text = input<I18nText | string>('')
  link_1_text = input<I18nText | string>('')
  link_1_url = input<string>('')
  link_2_text = input<I18nText | string>('')
  link_2_url = input<string>('')
  link_3_text = input<I18nText | string>('')
  link_3_url = input<string>('')
}
